import React, { createContext, useCallback, useContext, useState } from 'react';
import { TransitionType } from '../editor-property-panel/ui/contents/transition/transition-drag-data';
import { TransitionEdge } from './utils/transition-edge-utils';

export interface TransitionDropPreviewState {
  // 트랜지션 타입
  transitionType: TransitionType;
  // 트랜지션 이름
  name: string;
  // 경계 정보
  edge: TransitionEdge;
  // 드롭 가능 여부 (이미 트랜지션이 있으면 false)
  isAvailable: boolean;
}

interface TransitionDropPreviewContextValue {
  previewState: TransitionDropPreviewState | null;
  setPreviewState: (state: TransitionDropPreviewState | null) => void;
}

const TransitionDropPreviewContext =
  createContext<TransitionDropPreviewContextValue | null>(null);

export const TransitionDropPreviewProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [previewState, setPreviewState] =
    useState<TransitionDropPreviewState | null>(null);

  const value = {
    previewState,
    setPreviewState: useCallback(
      (state: TransitionDropPreviewState | null) => setPreviewState(state),
      [],
    ),
  };

  return (
    <TransitionDropPreviewContext.Provider value={value}>
      {children}
    </TransitionDropPreviewContext.Provider>
  );
};

export const useTransitionDropPreview = () => {
  const ctx = useContext(TransitionDropPreviewContext);
  if (!ctx) {
    throw new Error(
      'useTransitionDropPreview must be used within TransitionDropPreviewProvider',
    );
  }
  return ctx;
};
